module.exports = __webpack_public_path__ + "img/A.b97e1184.svg";